import styled from '@emotion/styled'

export const Status = styled.span`
  background: #f9fafc;
  border: 2px solid #d9e2ed;
  border-radius: 10px;
  padding-inline: 5px;
  padding-bottom: 1px;
  display: flex;
  font-size: 13px;
  color: #1C2025;
`

const colors = {
  OPEN: '#dbf5ff',
  CLOSED: '#e2e2e2',
  WAITING_FOR_USER_RESPONSE: '#d5ede1',
  SEEN: '#fff',
  SPELL: '#f5f5c3',
  ONGOING: '#ee90315c'
}

export const Card = styled.div`
  border-bottom: 1px solid #dadada;
  padding: 10px;
  padding-inline-start: 0;
  background: ${props => colors[props.status] };
`

export const ActionRow = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
`
